import { render, staticRenderFns } from "./FormCopm.vue?vue&type=template&id=9e5aadf4&scoped=true&"
import script from "./FormCopm.vue?vue&type=script&lang=js&"
export * from "./FormCopm.vue?vue&type=script&lang=js&"
import style0 from "./FormCopm.vue?vue&type=style&index=0&id=9e5aadf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5aadf4",
  null
  
)

export default component.exports